import CategoryCarousel from './CategoryCarousel';
import { CollectionData } from '@adapters/prismic/types/plp';

interface CategoryCarouselsProps {
  categoryCarousels: CollectionData['categoryCarousels'];
}

const CategoryCarousels = ({ categoryCarousels }: CategoryCarouselsProps) => {
  return (
    <section>
      {categoryCarousels.map((carousel) =>
        carousel.id ? (
          <CategoryCarousel key={carousel.id} carousel={carousel} />
        ) : null
      )}
    </section>
  );
};

export default CategoryCarousels;
